import { ButtonIcon, Spinner } from '@sonnen/web-ui';
import { CountryCode } from '@sonnen/web-utils';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../AppContext/AppContext';
import { HotlineOverlay } from '../../components/HotlineOverlay/HotlineOverlay';
import { OfferCalculationPage } from '../../components/OfferCalculationPage/OfferCalculationPage';
import { CurrentUserSiteOptionsCreateContractFlow } from '../../graphql/generated';
import { useTranslation } from '../../i18n/i18n';
import { OrderFlow } from '../../types';
import EnergyTariffCard from './EnergyTariffCard/EnergyTariffCard';
import styles from './TariffsComparison.module.css';

const TariffsComparison = () => {
  const [isHotlineOverlayOpen, setIsHotlineOverlayOpen] = useState(false);
  const { t, language } = useTranslation();
  const { userProcessing, setOrderFlow, selectedSite } = useAppContext();

  const hasFlatXContract =
    selectedSite?.options.createContractFlow ===
    CurrentUserSiteOptionsCreateContractFlow.SwitchFromFlatXContract;

  const isGermany = selectedSite?.address?.country === CountryCode.DE && language == 'de';

  useEffect(() => {
    setOrderFlow(null);
  }, [setOrderFlow]);

  const onOverlayClose = () => setIsHotlineOverlayOpen(false);

  return (
    <>
      <OfferCalculationPage
        title={
          <div className={styles.titleWithHotline}>
            {t('tariffsComparison.selectTariff')}
            {hasFlatXContract && isGermany && (
              <ButtonIcon
                onClick={() => setIsHotlineOverlayOpen(true)}
                dataTestId="hotline-info-icon"
                ariaLabel={t('hotline.infoIconAriaLabel')}
                icon="Info"
                iconColor="primary"
                size="xl"
              />
            )}
          </div>
        }
        dataTestId="tariffs-comparison"
      >
        {userProcessing ? (
          <div className={styles.spinnerWrapper}>
            <Spinner size="xl" accessibilityLabel={t('loadingUserDetails')} />
          </div>
        ) : (
          <div className={styles.cardsWrapper}>
            <EnergyTariffCard flow={OrderFlow.energyDynamic} />
            <EnergyTariffCard flow={OrderFlow.energyFix} />
          </div>
        )}
      </OfferCalculationPage>
      {isHotlineOverlayOpen && <HotlineOverlay onClose={onOverlayClose} />}
    </>
  );
};
export default TariffsComparison;
